import * as types from './action-types';

export const addPromoItems = promoItems => ({
    type: types.ADD_PROMO_ITEMS,
    promoItems
});

export const deletePromoItems = promoItems => ({
    type: types.DELETE_PROMO_ITEMS,
    promoItems
});



// WEBPACK FOOTER //
// ./src/actions/promo-items.js